import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  IconButton,
  Button,
  MenuItem,
  TextField,
  InputAdornment,
  Grid,
  Stack,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { TOTALLIMIT } from "../../../utils/localStorage";
import { Search } from "@mui/icons-material/";
import { styled } from "@mui/material/styles";
import OpenEyeIcon from "../../../assets/icons/OpenEyeIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContentEyeIcon from "../../../assets/icons/ContentEyeIcon.svg";
import Switch from "@mui/material/Switch";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import AddVesselAdminMasterModel from "./AddVesselAdminMasterModel";
import { useNavigate } from "react-router-dom";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import moment from "moment";
import noData from "../../../assets/images/Group 688.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import EditVesselAdminMasterModel from "./EditVesselAdminMasterModel";
import {
  setIsOpenModelAddUserMaster,
  setIsOpenModelEditUserMaster,
  deleteUserMasterList,
  updateUserMasterList,
  getUserMasterList,
} from "../../../redux/actions/mastersAction";
import { GenerateDisplayId } from "../../../utils/GenerateDisplayId";
import DeleteModel from "../../CommonComponent/DeleteModel";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const VesselAdminMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const [isdeleteModel, setIsdeleteModel] = useState(false);
  const VessalAdminID = localStorage.getItem("VessalAdminID");
  const [CompanyVesselDeleteID, setCompanyVesselDeleteID] = useState("");
  const CompanyID = localStorage.getItem("companyID");
  const [FirstNameSearchValue, setFirstNameSearchValue] = useState("");
  const paginationForMaster = useSelector(
    (state) => state?.masters?.paginationForMaster
  );

  const AddVesselAdminModel = useSelector(
    (state) => state?.masters?.models?.AddUserMasterModel
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );
  const [selectedRow, setSelectedRow] = useState(null);

  const [VesselName, setVesselName] = useState("");
  const [isActive, setIsActive] = useState("true");

  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangePage = (e, pagevalue) => {
    setPage(pagevalue);
  };

  const handleChangeIsActive = (event) => {
    setIsActive(event.target.value);
  };

  const handleChangeFirstNameSearchValue = (event) => {
    setFirstNameSearchValue(event.target.value);
  };

  const handleChangeVesselName = (event) => {
    setVesselName(event.target.value);
  };

  const handleShowPassword = (index) => {
    if (selectedRow === index) {
      setSelectedRow(null);
    } else {
      setSelectedRow(index);
    }
  };

  const handleDeleteVesselAdmin = () => {
    dispatch(
      deleteUserMasterList({
        id: CompanyVesselDeleteID,
        roleId: VessalAdminID,
      })
    );
    handleClosedeleteModel();
  };
  const toggleActiveStatus = (VesselAdminrow) => {
    dispatch(
      updateUserMasterList({
        id: VesselAdminrow?.id,
        active: !VesselAdminrow?.active,
        role_id: VessalAdminID,
      })
    );
  };

  const handleEditVesselAdmin = (VesselAdminRowData) => {
    const payload = {
      isOpenEditModel: true,
      EditRowDataModel: VesselAdminRowData,
    };
    dispatch(setIsOpenModelEditUserMaster(payload));
  };

  useEffect(() => {
    dispatch(setIsOpenModelAddUserMaster(false));
    const payload = {
      isOpenEditModel: false,
      EditRowDataModel: [],
    };
    dispatch(setIsOpenModelEditUserMaster(payload));
  }, [dispatch]);

  const handleClosedeleteModel = (e) => {
    setIsdeleteModel(false);
  };

  const onExportHandler = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportFormShape = userMasterData
      .sort((a, b) => b.display_id - a.display_id)
      .map((user) => {
        return {
          ID: GenerateDisplayId("MMVA", user?.display_id),
          "First Name": user.first_name,
          "Last Name": user.last_name,
          "User Name": user.username,
          "Email ID": user.email,
          "Mobile No.": user.phone,
          Password: user.password,
          "Created Date And Time": moment(user?.createdAt).format(
            "D MMMM, YYYY | hh:mm A"
          ),
          "Modified Date And Time": moment(user?.updatedAt).format(
            "D MMMM, YYYY | hh:mm A"
          ),
        };
      });
    const ws = XLSX.utils.json_to_sheet(exportFormShape);

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Vessel Admin Master" + fileExtension);
  };
  // useEffect(() => {
  //   if (!AddVesselAdminModel) {
  //     setIsActive("true");
  //     setFirstNameSearchValue("");
  //     setVesselName("");
  //     setIsPaginationLimit(10);
  //     setPage(1);
  //   }
  // }, [AddVesselAdminModel]);

  useEffect(() => {
    dispatch(
      getUserMasterList({
        roleId: VessalAdminID,
        companyId: CompanyID,
        active: isActive,
        searchByVesselId: VesselName,
        searchByFirstName: FirstNameSearchValue,
        limit: isPaginationLimit,
        offset: page - 1,
      })
    );
  }, [isActive, VesselName, FirstNameSearchValue, isPaginationLimit, page]);

  const userMasterData = useSelector((state) => state?.masters?.userMasterData);
  console.log("userMasterData", userMasterData.length);
  return (
    <>
      {isdeleteModel && (
        <DeleteModel
          isdeleteModel={isdeleteModel}
          handleClosedeleteModel={handleClosedeleteModel}
          handleDelete={handleDeleteVesselAdmin}
        />
      )}
      <AddVesselAdminMasterModel />

      <EditVesselAdminMasterModel />

      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Vessel Admin Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <Select
              value={VesselName}
              onChange={handleChangeVesselName}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="16"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "37px",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                backgroundColor: "#E5F1EB",
                border: "none",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value="">All</MenuItem>
              {vesselMasterData.map((row) => (
                <MenuItem value={row?.id}>{row?.name}</MenuItem>
              ))}
            </Select>
            <Select
              value={isActive}
              onChange={handleChangeIsActive}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="16"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "37px",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                backgroundColor: "#E5F1EB",
                border: "none",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">InActive</MenuItem>
            </Select>
            <TextField
              size="small"
              placeholder="Search First Name"
              value={FirstNameSearchValue}
              onChange={handleChangeFirstNameSearchValue}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "#20724E" }} />
                  </InputAdornment>
                ),
                style: {
                  height: "2.3rem",
                  borderRadius: "10px",
                  color: "#20724E",
                  fontWeight: "bold",
                  width: "15rem",
                  backgroundColor: "#E5F1EB",
                },
              }}
              sx={{
                mr: 2,
                ml: 1,
                border: "none",
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            {/* <Box>
              <TextField
                size="small"
                placeholder="Search Vessel Name"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: "#20724E" }} />
                    </InputAdornment>
                  ),
                  style: {
                    height: "2.3rem",
                    borderRadius: "10px",
                    color: "#20724E",
                    fontWeight: "bold",
                    width: "15rem",
                    backgroundColor: "#E5F1EB",
                  },
                }}
                // onChange={filterBySearch}
                sx={{
                  mr: 2,
                  ml: 1,
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", 
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box> */}
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "10px", mr: 2 }}
            >
              <Button
                variant="outlined"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  borderColor: "#26875C",
                  width: "6rem",
                  backgroundColor: "FFFFFF",
                  padding: "6px 0px 4px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  ":hover": {
                    borderColor: "#26875C",
                  },
                }}
                onClick={() => dispatch(setIsOpenModelAddUserMaster(true))}
              >
                <Box sx={{ marginRight: "10px" }}>
                  <img src={ActiveAddButton} alt="" />
                </Box>
                Add
              </Button>
              <Button
                variant="contained"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "6rem",
                  backgroundColor: "#26875C",
                  padding: "7px 0px 5px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                // onClick={() => setIsEditVesselAdminMasterModel(true)}
                onClick={() => (isLoading ? null : onExportHandler())}
              >
                Export
              </Button>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {userMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      First Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Last Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      User Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Mobile No.
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vessel
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Password
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Status
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created Date and Time
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Modified Date and Time
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={11} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {userMasterData?.map((row, index) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {GenerateDisplayId("MM" + "VA", row?.display_id)}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.first_name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.last_name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.username}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.email}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.phone}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {row?.vessel_info?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          <div
                            style={{
                              position: "relative",
                              display: "flex",
                              alignItems: "start",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type={selectedRow === index ? "text" : "password"}
                              value={row?.password}
                              readOnly
                              style={{ border: "none", outline: "none" }}
                            />
                            <img
                              src={
                                selectedRow === index
                                  ? OpenEyeIcon
                                  : ContentEyeIcon
                              }
                              alt=""
                              onClick={() => handleShowPassword(index)}
                              style={{
                                marginLeft: "35px",
                                position: "absolute",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          <Box onClick={() => toggleActiveStatus(row)}>
                            <AntSwitch checked={row?.active} color="primary" />
                          </Box>
                        </TableCell>
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {moment(row?.createdAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell> */}
                        <TableCell sx={{ color: "#464E5F", fontWeight: "600" }}>
                          {moment(row?.updatedAt).format(
                            "D MMMM, YYYY | hh:mm A"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            textAlign: "left",
                            display: "flex",
                          }}
                        >
                          <IconButton>
                            <img
                              src={EditButton}
                              width="30"
                              height="30"
                              onClick={() => handleEditVesselAdmin(row)}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setCompanyVesselDeleteID(row?.id);
                              setIsdeleteModel(true);
                            }}
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {paginationForMaster?.totalRecord >= TOTALLIMIT > 0 && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "4vh",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={paginationForMaster?.totalPages}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default VesselAdminMasterContent;
